module.exports = "/_next/static/images/303ea25928b6a0afb4eedf711074b83b-nucommunity-lg@3x.jpg";